import { Button } from "@mui/material";

const AppButton = ({ children, sx = {}, ...props }) => (
  <Button
    variant="contained"
    disableElevation
    sx={{
      textTransform: 'capitalize',
      background: 'black',
      color: 'white',
      fontWeight: 500,
      fontSize: { xs: '0.78rem', sm: '0.875rem' },
      px: { xs: 1.8, sm: 2.5 },
      py: { xs: 0.6, sm: 0.85 },
      borderRadius: 1.5,
      letterSpacing: 0.3,
      '&:hover': { background: '#222' },
      '&.Mui-disabled': { background: '#ccc', color: '#888' },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Button>
);

export default AppButton;
